const chatModule = {
  init() {
    /**
     * Created by Modestas on 09/10/2017.
     */
    var version = "v10.0";
    var timeout = 1;
    var pointOfContact = "a690e809-cf69-4f5e-b7d2-902664f30edf";

    var messagesTemp = [];
    const $ = window.jQuery;

    if (!$ || !$.ajax ) {
      return;
    }

    const $chatToggle = $(".chat-toggle");

    if (!$chatToggle.length) {
      return;
    }

    function setTime(timestamp) {
      var time = timestamp ? new Date(timestamp) : new Date();
      var cHour = time.getHours();
      var cMin = time.getMinutes();
      if (cHour < 10) cHour = "0" + cHour;
      if (cMin < 10) cMin = "0" + cMin;
      return (time = { hours: cHour, minutes: cMin });
    }

    function deleteElements() {
      if ($("#chat").is(":visible")) {
        $(".chat-toggle img").toggleClass("hidden");
      }

      $chatToggle.removeClass("opened");
      $(".overflow-msg,#chat").fadeOut(200);
      $("#chat .body").html("");

      localStorage.removeItem("chatStatus");
      localStorage.removeItem("authInfo");
      localStorage.removeItem("chatInfo");
    }

    var chatFunctions = {
      getSession(newChat) {
        if (localStorage.getItem("authInfo")) {
          var accessToken = JSON.parse(
            localStorage.getItem("authInfo")
          ).access_token;
          var baseURI = JSON.parse(
            localStorage.getItem("authInfo")
          ).resource_server_base_uri;
        }

        var chatID;

        if (accessToken && baseURI) {
          if (localStorage.getItem("chatInfo")) {
            chatID = JSON.parse(localStorage.getItem("chatInfo")).chatSessionId;
          }

          if (chatID) {
            $.ajax({
              url:
                baseURI +
                "services/" +
                version +
                "/contacts/chats/" +
                chatID +
                "?timeout=" +
                timeout,
              type: "GET",
              headers: {
                Authorization: "bearer " + accessToken,
                "content-Type": "application/json",
              },
              success: function (result) {
                //get all previous messages

                // if(result && result.chatSession){
                //     localStorage.removeItem('currentChat');
                //     localStorage.setItem('currentChat', JSON.stringify(result.chatSession));
                // }

                if (result && result.messages.length) {
                  var agentName;

                  var statusMessage = false;
                  result.messages.filter(function (message) {
                    if (message && message.Type === "Status") {
                      statusMessage = true;
                      $("#status").html(message.Status);
                    }
                  });

                  if (result.messages.length > 0) {
                    //get difference between old and new messages
                    var count = result.messages.length - messagesTemp.length;

                    //show only new messages
                    var newMessages = [];
                    if (result.messages.length - messagesTemp.length > 0) {
                      newMessages = result.messages.slice(
                        Math.max(result.messages.length - count, 1)
                      );
                    }
                    if (newChat) {
                      newMessages = result.messages;
                    }

                    //save new messages for later compare
                    messagesTemp = result.messages;

                    newMessages.forEach(function (message) {
                      //TODO pagal ka skirt kas atsiunte zinute?
                      if (message && message.PartyTypeId) {
                        var user = message.PartyTypeId == 3 ? "client" : "agent";
                        var bubbleClass = user == "agent" ? "right" : "left";
                        var bubbleClass2 = user == "agent" ? "" : "blue";
                        var time = setTime(message.Timestamp);
                        var name = message.PartyTypeId == 3 ? "Me" : message.Label;

                        if (message.Text) {
                          $("#chat .body").append(
                            '<div class="message ' +
                              bubbleClass2 +
                              '"><div class="arrow-triangle ' +
                              bubbleClass +
                              '"></div><div class="message-head"><span>' +
                              name +
                              "</span><span>" +
                              time.hours +
                              ": " +
                              time.minutes +
                              '</span></div><div class="message-body">' +
                              message.Text +
                              "</div></div>"
                          );
                        }

                        $("#chat .body").scrollTop(
                          $("#chat .body")[0].scrollHeight
                        );
                      }
                    });
                  }
                }

                $("#chat .overflow").fadeOut(200);
                console.log("getting new messages");

                return result;
              },
              error: function (XMLHttpRequest, textStatus, errorThrown) {
                if (XMLHttpRequest && XMLHttpRequest.status === 404) {
                  console.log("session end");
                  deleteElements();
                }
                return false;
              },
            });
          }
        }
      },
      create() {
        var accessToken = JSON.parse(localStorage.getItem("authInfo")).access_token;
        var baseURI = JSON.parse(
          localStorage.getItem("authInfo")
        ).resource_server_base_uri;

        //check if chat exists
        if (!localStorage.getItem("chatInfo")) {
          var createChatSessionPayload = {
            pointOfContact: pointOfContact,
          };

          console.log("create new chat");

          $.ajax({
            url: baseURI + "services/" + version + "/contacts/chats",
            type: "POST",
            headers: {
              Authorization: "bearer " + accessToken,
              "content-Type": "application/json",
            },
            data: JSON.stringify(createChatSessionPayload),
            beforeSend: function () {
              // setting a timeout
            },
            success: function (result) {
              localStorage.removeItem("chatInfo");
              localStorage.setItem("chatInfo", JSON.stringify(result));
              chatFunctions.getSession(true);
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
              return false;
            },
          });
        } else {
          //get available chat
          console.log("load existing chat");
          this.getSession();
        }
      },
      send(message) {
        var accessToken = JSON.parse(localStorage.getItem("authInfo")).access_token;
        var baseURI = JSON.parse(
          localStorage.getItem("authInfo")
        ).resource_server_base_uri;
        var chatSessionId = JSON.parse(
          localStorage.getItem("chatInfo")
        ).chatSessionId;
        var sendSingleChatMessagePayload = {
          message: message,
        };

        if (!chatSessionId && localStorage.getItem("chatInfo")) {
          chatSessionId = JSON.parse(
            localStorage.getItem("chatInfo")
          ).chatSessionId;
        }

        $.ajax({
          url:
            baseURI +
            "services/" +
            version +
            "/contacts/chats/" +
            chatSessionId +
            "/send-text",
          type: "POST",
          headers: {
            Authorization: "bearer " + accessToken,
            "content-Type": "application/json",
          },
          data: JSON.stringify(sendSingleChatMessagePayload),
          success: function (result) {
            chatFunctions.getSession();
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            //Process error actions
            return false;
          },
        });
      },
      typing() {
        var chatSessionId = JSON.parse(
          localStorage.getItem("chatInfo")
        ).chatSessionId;
        var accessToken = JSON.parse(localStorage.getItem("authInfo")).access_token;
        var baseURI = JSON.parse(
          localStorage.getItem("authInfo")
        ).resource_server_base_uri;
        $.ajax({
          url:
            baseURI +
            "services/" +
            version +
            "/contacts/chats/" +
            chatSessionId +
            "/typing",
          type: "POST",
          headers: {
            Authorization: "bearer " + accessToken,
            "content-Type": "application/json",
          },
          success: function (result) {
            //Process success actions
            return result;
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            //Process error actions
            return false;
          },
        });
      },
      delete() {
        var chatSessionId = JSON.parse(
          localStorage.getItem("chatInfo")
        ).chatSessionId;
        var accessToken = JSON.parse(localStorage.getItem("authInfo")).access_token;
        var baseURI = JSON.parse(
          localStorage.getItem("authInfo")
        ).resource_server_base_uri;
        $.ajax({
          url: baseURI + "services/" + version + "/contacts/chats/" + chatSessionId,
          type: "DELETE",
          headers: {
            Authorization: "bearer " + accessToken,
            "content-Type": "application/x-www-form-urlencoded",
          },
          success: function () {
            console.log("deleted");
            deleteElements();
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            //Process error actions
            return false;
          },
        });
      },
    };

    localStorage.removeItem("authInfo");
    var baseURI = "https://api.incontact.com/InContactAuthorizationServer/Token";

    //generated code
    var authCode = "VEpIQFRKSDpOamN5TTJSbFltSXpNbVV3TkdNeU5EZzBZV1psTmpnMk56RXpZekkyWkdVPQ==";

    //-------- also can do this is the same and generate code manually -----------//
    // var application = "TJH";
    // var vendor = "TJH";
    // var applicationId = "NjcyM2RlYmIzMmUwNGMyNDg0YWZlNjg2NzEzYzI2ZGU=";
    // var authCode = window.btoa(application + "@" + vendor + ":" + applicationId);

    var token = {
      get() {
        jQuery.ajax({
          url: baseURI,
          type: "POST",
          headers: {
            Authorization: "basic " + authCode,
            "Content-Type": "application/json",
          },
          data: JSON.stringify({
            grant_type: "client_credentials",
            scope: "PatronAPI",
          }),
          success: function (result) {
            if (result) {
              localStorage.setItem("authInfo", JSON.stringify(result));
              chatFunctions.create();
            }
            return result;
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            //Process error actions
            return false;
          },
        });
      },
    };

    //start chat session
    $(() => {
      //toggle chat
      $chatToggle.click(function () {
        //create chat session if chat opened first time
        if (!$(this).hasClass("opened")) {
          //get user token
          token.get();
          $(this).addClass("opened");
        }

        $(".chat-toggle img").toggleClass("hidden");
        $("#chat .body").scrollTop($("#chat .body")[0].scrollHeight);
        $("#chat .overflow").fadeIn(200);
        $("#chat").fadeToggle(200);
      });

      //-----------------  send message  ---------------//

      function sendMessage() {
        var textarea = $("#text-area");
        if (textarea.val()) {
          chatFunctions.send(textarea.val());
          textarea.val("");
        }
      }

      //if enter is clicked on input send

      $(document).keypress(function (e) {
        if (e.which == 13) {
          //TODO reset cursor location after send

          if ($("#text-area").is(":focus")) {
            sendMessage();
            $("#text-area").blur();
          }
        }
      });

      //if send button clicked
      $("#btn-send").click(function () {
        sendMessage();
      });

      //-----------------  send message end ---------------//

      //-----------------  destroy chat ---------------//

      $("#toggle-end-overview").click(function () {
        $(".overflow-msg").fadeIn(200);
      });
      $("#destroy-chat").click(function () {
        chatFunctions.delete();
      });
      $("#cancel-destroy").click(function () {
        $(".overflow-msg").fadeOut(200);
      });

      //-----------------  destroy chat end ---------------//

      //-----------------  get new messages live ---------------//

      window.setInterval(function () {
        chatFunctions.getSession();
      }, 4000);

      //-----------------  get new messages live end ---------------//

      //----------------- Typing ------------------//

      var delay = (function () {
        var timer = 0;
        return function (callback, ms) {
          clearTimeout(timer);
          timer = setTimeout(callback, ms);
        };
      })();

      $("#text-area").keyup(function () {
        delay(function () {
          chatFunctions.typing();
        }, 500);
        autosize($(this));
      });

      //----------------- Typing END ------------------//

      //auto resize textarea
      function autosize(el) {
        el.css("height", "20px");
        el.css("height", el.prop("scrollHeight") + "px");
      }
    });

  }
};

export default chatModule;